import { getContext } from '@fiverr-private/fiverr_context';
import { injectTemplates } from '../shared/injectTemplates';
import propTypes from './propTypes';

const I18n = ({
    k,
    templates = {},
    params = {},
    locale: localeFromProps
}) => {
    if (!k) {
        return null;
    }

    const { locale: localeFromContext } = getContext();
    const locale = localeFromProps || localeFromContext;
    let output;

    try {
        output = i18n.t(k, { ...params, $scope: locale });
    } catch (e) {
        output = k;
    }

    return injectTemplates(output, templates);
};

I18n.propTypes = {
    ...propTypes
};

export default I18n;
